import { RECHARGE_CLAIM_TYPE } from './index.js'

/**
 * 充值签收弹窗（recharge）打开参数
 * @param {{ totalBonus?: number, depositAmount?: number }} payload
 */
export const createRechargeOpenPayload = (payload = {}) => ({
  type: RECHARGE_CLAIM_TYPE.RECHARGE,
  totalBonus: Number(payload.totalBonus) || 0,
  depositAmount: Number(payload.depositAmount) || 0,
})

/**
 * 充值成功弹窗（redeemed）打开参数
 * @param {{ totalBonus?: number }} payload
 */
export const createRedeemedOpenPayload = (payload = {}) => ({
  type: RECHARGE_CLAIM_TYPE.REDEEMED,
  totalBonus: Number(payload.totalBonus) || 0,
  depositAmount: 0,
})

/**
 * 将打开参数写入 rechargePayload
 * @param {object} target - 父级 reactive 对象
 * @param {object} payload - createRechargeOpenPayload / createRedeemedOpenPayload 返回值
 */
export const applyRechargeClaimPayload = (target, payload) => {
  target.type = payload.type
  target.totalBonus = payload.totalBonus
  target.depositAmount = payload.depositAmount
}
